export enum DIALOG_TYPES {
  // EDIT_LISTENER,
  // EDIT_POOL,
  EDIT_L7POLICY,
  DELETE_L7POLICY,
  CERATE_L7RULE,
  EDIT_L7RULE,
  DELETE_L7RULE
}
